import type { AiBusinessCenterModule } from '../types'

export const mesModule: AiBusinessCenterModule = {
  key: 'mes',
  label: 'MES系统',
  desc: '生产排程 / 工单管理 / 质量追溯 / 设备管理',
  path: '/mes',
  homePath: '/mes/dashboard',
  icon: 'ep:cpu',
  color: '#ef4444',
  aliases: ['MES 系统', 'MES制造执行系统', 'MES制造执行', 'MES']
}
